exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "::ng-deep .mat-form-field-underline {\n  display: none !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agir/src/app/components/project-overview-admin/project-overview-admin.component.scss
// module id = ../../../../../src/app/components/project-overview-admin/project-overview-admin.component.scss
// module chunks = main